import React from 'react';
import PropTypes from 'prop-types';

import { capitalize } from 'lodash';
import { connect } from 'react-redux';
import { updateSelectedStage  } from 'bundles/apex/pipeline/settings/store/actions';

import { getOrderedStages } from 'bundles/apex/helpers/stages';
import Stage from './stage';
import EditStageModal from './modal';

export function PipelineSettingsStages({
  selectedStage,
  stages,
  updateSelectedStage
}) {
  const orderedStages = getOrderedStages(stages);

  return (
    <div className="stages-settings mt-3">
      <div className="d-flex flex-column gap-3">
        {orderedStages.map(({ key }) => (
          <Stage
            key={key}
            stage={stages[key]}
            onClick={() => updateSelectedStage(stages[key])}
          />
        ))}
      </div>
      <EditStageModal
        defaultLabel={capitalize(selectedStage?.key)}
        show={!!selectedStage}
        stage={selectedStage}
        onHide={() => updateSelectedStage(null)}
      />
    </div>
  );
}

PipelineSettingsStages.propTypes = {
  selectedStage: PropTypes.object,
  stages: PropTypes.object.isRequired,
  updateSelectedStage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedStage: state.selectedStage,
  stages: state.stages,
});

const mapDispatchToProps = {
  updateSelectedStage,
};

export default connect(mapStateToProps, mapDispatchToProps)(PipelineSettingsStages);
